module.exports = "<div class=itemDetailsTransactions ng-cloak layout=row> <div ng-if=\"c.transactions && c.transactions.length === 0\" flex layout=row> <span flex=30></span> <div layout=row flex> <div class=\"circle md-whiteframe-z2\" layout=row layout-align=\"center center\"> <h3 class=white-text>Ingen transaksjoner</h3> </div> </div> </div> <md-card ng-if=\"c.tableDefinition.promise || c.transactions.length > 0\" flex> <rkc-table table-definition=c.tableDefinition table-content=c.transactions></rkc-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/items/itemDetails/itemDetailsTransactions/itemDetailsTransactions.html
 ** module id = 505
 ** module chunks = 0
 **/